import { ResourceWatchNotification } from './ResourceWatchNotification';

/** Agora notification type codes from notification-svc. */
export const NotificationTypes = {
    RES_WATCH: 'RES_WATCH',
};

/** Maps notification type codes to row components. */
export const NotificationComponentMap = {
    [NotificationTypes.RES_WATCH]: ResourceWatchNotification,
};
